import { ContactPreferences } from "@seneca/notifications-service-types";
import { PreferenceOptions } from "../../../../notifications/types";

export function getIsTopicChecked(
  preferences: ContactPreferences | undefined,
  field: keyof PreferenceOptions
) {
  const isTopicBox = field !== "subscribed";
  const isSubscribedToTopic = preferences?.[field];
  const isSubscribedAll = preferences?.subscribed;

  const isChecked = isSubscribedToTopic && isSubscribedAll;

  return isTopicBox ? isChecked : !isChecked;
}
